import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const DashBanner = ({ title, description }) => {
  const storageKey = `db_banner_hide_until_${title.replace(/\s/g, "_")}`;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hideUntil = localStorage.getItem(storageKey);
    if (hideUntil && Date.now() < Number(hideUntil)) {
      setIsVisible(false);
    } else {
      localStorage.removeItem(storageKey);
      setIsVisible(true);
    }
  }, [storageKey]);

  const handleClose = () => setIsVisible(false);

  const handleHideToday = () => {
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);
    localStorage.setItem(storageKey, String(midnight.getTime()));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="relative mb-6 p-6 rounded-2xl bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-100 shadow-sm animate-fade-in-up">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4 pr-8">
        <div className="flex-1">
          <h2 className="text-2xl font-bold text-gray-800 mb-2 flex items-center gap-2">
            {title}
          </h2>
          <p className="text-gray-600 leading-relaxed max-w-4xl">
            {description}
          </p>
        </div>
      </div>

      {/* 하단 액션 영역 */}
      <div className="mt-4 flex items-center justify-end">
        <button
          onClick={handleHideToday}
          className="text-sm text-gray-800 hover:text-black underline underline-offset-2 transition-colors"
        >
          오늘 하루 보지 않기
        </button>
      </div>

      {/* 닫기 버튼 */}
      <button
        onClick={handleClose}
        className="absolute top-4 right-4 p-2 text-gray-800 hover:text-black hover:bg-white/50 rounded-full transition-all"
        title="닫기"
      >
        <X size={20} />
      </button>
    </div>
  );
};

export default DashBanner;
